// src/routes/appRoutes.js
import {
  generateClientRoutes,
  getClientName,
  getTenantFromToken
} from 'utils/routeUtils';
import offlineRoutes from './offlineRoutes';

const getAppRoutes = () => {
  return new Promise((resolve, reject) => {
    // Check if the user is offline
    const isOffline = !navigator.onLine;

    // If offline, immediately resolve with offline routes
    if (isOffline) {
      resolve([
        {
          label: 'Offline Mode',
          children: offlineRoutes
        }
      ]);
      return;
    }

    function checkTokenAndGenerate() {
      const tenantId = getTenantFromToken();
      if (tenantId) {
        const clientName = getClientName();
        const routes = generateClientRoutes(clientName, tenantId);
        resolve(routes);
      } else {
        setTimeout(checkTokenAndGenerate, 1000);
      }
    }

    checkTokenAndGenerate();
  });
};

export const appRoutes = getAppRoutes;
export default appRoutes;
